import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { LogIn, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError, mediaUrl } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(apiError(err, "Connexion impossible"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-onyx flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={mediaUrl("/api/uploads/logo-blanc-transparent.png")} alt="Douzième Homme — Le Jeu" className="h-20 w-auto mx-auto mb-4" />
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-rouge-light font-bold mt-1">Back-office</p>
        </div>
        <form onSubmit={submit} className="bg-white p-7 sm:p-8 space-y-4" data-testid="admin-login-form">
          <div className="flex items-center gap-2 text-onyx mb-1">
            <Lock className="w-4 h-4 text-rouge" />
            <h1 className="font-display font-bold text-lg">Connexion administrateur</h1>
          </div>
          <div>
            <Label htmlFor="admin-email">Email</Label>
            <Input id="admin-email" type="email" data-testid="admin-email" required autoComplete="email"
              value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="admin-password">Mot de passe</Label>
            <Input id="admin-password" type="password" data-testid="admin-password" required autoComplete="current-password"
              value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
          </div>
          {error && <p className="text-sm font-semibold text-destructive" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-rouge text-white px-6 py-3.5 text-sm font-bold uppercase tracking-wide hover:bg-rouge-hover transition-colors disabled:opacity-50">
            <LogIn className="w-4 h-4" /> {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
        <p className="text-center text-xs text-cream/40 mt-6">Accès réservé au propriétaire du site.</p>
      </div>
    </div>
  );
}
